import { FFEDocument, Group } from '../../../types/ffe'
import { PrintLineItem } from './PrintLineItem'

export const TableItemIndent = ({ depth }: { depth: number }) => {
  if (depth === 0) return null
  return (
    <>
      {Array.from({ length: depth }).map((_, i) => (
        <div
          key={i}
          className={`h-auto w-[6px] ${i === 0 ? 'bg-gray-200' : ''} ${i >= 1 ? 'bg-gray-100' : ''}`}
          style={{ marginLeft: `${i === 0 ? 0 : 14}px` }}
        ></div>
      ))}
    </>
  )
}

export const PrintGroup = ({
  group,
  document,
  depth
}: {
  group: Group
  document: FFEDocument
  depth: number
}) => {
  const groupLineItems = document.lineItems.filter(
    (item) => item.groupId === group.id
  )
  const groupedGroups = document.groups.filter((g) => g.groupId === group.id)
  return (
    <>
      <tr className="p-0 break-after-avoid">
        <td
          colSpan={5}
          className="font-semibold p-0"
          style={{
            fontSize: depth === 0 ? '0.95rem' : undefined
          }}
        >
          <div className="flex items-stretch">
            <TableItemIndent depth={depth} />
            <div
              className={`mt-[14px] rounded-tl-lg rounded-tr-lg rounded-br-lg pr-4 flex-1 py-2 pl-2 border-solid border-l ${depth === 0 ? 'bg-gray-200 border-gray-200' : ''} ${depth === 1 ? 'bg-gray-100 border-gray-100' : ''} ${depth > 1 && 'border-gray-100'}`}
              style={{
                borderLeftWidth: '6px',
                marginLeft: `${depth === 0 ? 0 : 14}px`
              }}
            >
              {group.name}
              {group.isAlternatives && (
                <span className="ml-2 text-orange-500 font-normal">
                  (Select one)
                </span>
              )}
            </div>
          </div>
        </td>
      </tr>
      {groupedGroups.map((item) => (
        <PrintGroup
          key={item.id}
          group={item}
          document={document}
          depth={depth + 1}
        />
      ))}
      {groupLineItems.map((item) => (
        <PrintLineItem
          key={item.id}
          item={item}
          group={group}
          materials={document.materials}
          documentSettings={document.settings}
          depth={depth + 1}
        />
      ))}
    </>
  )
}
